goog.module('yext.developerapps.wazeadssyncing.WazeSyncNow');
goog.module.declareLegacyNamespace();

const routes = goog.require('yext.developerapps.routes');
const Field = goog.require('yext.developerapps.wazeadssyncing.Field');

const WazeSyncNow = class
  extends Field {
  constructor() {
    super($('.js-wazeadssyncing-sync-now'));
  }

  /** @override */
  doSubmit_(data) {
    this.$editMode.find('.icon-loading').show();
    return $.ajax({
      method: 'POST',
      url: routes.WazeAdsSyncing.syncNow(),
      data: data,
    })
      .done(function(resp) {
        if (resp['success']) {
          window.location.href = routes.WazeAdsSyncing.view();
        } else {
          this.showGenericError_(resp['error']);
        }
      }.bind(this));
  }
};

goog.exportSymbol('yext.developerapps.wazeadssyncing.WazeSyncNow',
  WazeSyncNow);

exports = WazeSyncNow;
